<script lang="ts">
    import type { AppOptionsType } from './EasyVrpApp.types';

    export let componentProps: {
        extra_data: AppOptionsType;
    };
</script>

<div class="time-story-container">
    <pre>{JSON.stringify(componentProps.extra_data, null, 2)}</pre>
</div>

<style>
    .time-story-container {
        width: 100%;
        overflow-x: auto;
    }

    pre {
        font-family: monospace;
        white-space: pre;
        margin: 0;
        padding: 10px;
        background-color: #f5f5f5;
        border-radius: 4px;
    }
</style>
